import React, { Component } from 'react';
import { Select, Input, Divider, Row, Button, message, InputNumber, DatePicker, Table } from 'antd';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { formatMoney, showErrorInNotification } from '../../../lib/util';
import Form from '../../../lib/ui/form';
import moment from "moment";


class RefillATMAddEdit extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      form_data: this.props.edit_data || {
        cash_cassettes:[
        {
            "deno": 500, "qty": 0, "amt": 0, "cassette_type": ""
        },
        {
            "deno": 500, "qty": 0, "amt": 0, "cassette_type": ""
        },
        {
            "deno": 1000, "qty": 0, "amt": 0, "cassette_type": ""
        },
        {
            "deno": 1000, "qty": 0, "amt": 0, "cassette_type": ""
        }
        ],
        divert_cassettes:[
          {
            "deno": 500, "qty": 0, "amt": 0, "cassette_type": ""
        },
        {
            "deno": 1000, "qty": 0, "amt": 0, "cassette_type": ""
        },
        ],
        new_added: [
          {
              "deno": 500, "qty": 0, "amt": 0, "cassette_type": ""
          },
          {
              "deno": 1000, "qty": 0, "amt": 0, "cassette_type": ""
          }
      ],
      num_bills_replenished: [
          {
              "deno": 500, "qty": 0, "amt": 0
          },
          {
              "deno": 1000, "qty": 0, "amt": 0
          }
      ]
      },
      edit_id: this.props.edit_id,
      searchQuery: null,
      savedSources:this.props.edit_data?.source_name?{
        [this.props.edit_data?.source_id]:{
          source_id:this.props.edit_data?.source_id,
          name:this.props.edit_data?.source_name}
      }:{},
    }
    // this.listSourcesExecutor=RESTExecutor.list().config({
    //   label:''
    // }).connect(props.domains.)

    this.listSourcesExecutor = RESTExecutor.list().config({
      label: 'my_sources',
    }).callbacks((success)=>{
      let result=success?.result?.rows??[];
      let prev=this.state.savedSources??{};
      result.forEach((resultItem)=>{
        prev[resultItem.source_id]=resultItem
      });
      this.setState({
        savedSources:prev
      })
    }).connect(props.domains.usergroups);


    this.postExecutor = RESTExecutor.post().config({
      label: 'atm_refill_list'
    }).callbacks((success) => {
      message.success("Config Added Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.activity);

    this.patchExecutor = RESTExecutor.patch().config({
      label: 'atm_refill_detail',
    }).callbacks((success) => {
      message.success("Config Modified Successfully");
      typeof this.props.onRefreshClose === 'function' && this.props.onRefreshClose()

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.activity);

    this.listSourcesExecutor.execute();


  }
  

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    // console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  handlePostPatch = () => {
    let _formdata=new FormData();
    Object.keys(this.state.form_data).map((key)=>{
      if(['cash_cassettes','divert_cassettes','new_added','num_bills_replenished'].includes(key)){
        _formdata.append(key,JSON.stringify(this.state.form_data[key]))
      }else{
        _formdata.append(key,this.state.form_data[key])
      }
    
    })
    if (this.state.edit_id) {
      this.patchExecutor.forId(this.state.edit_id).execute(_formdata)
    } else {
      this.postExecutor.execute(_formdata);
    }
  }

  render() {
     const {form_data,savedSources} = this.state;
     console.log("form_data",form_data)
     const sourceList=Object.values(savedSources).filter(a=>a?.name!=null)
     const {cash_cassettes=[],divert_cassettes=[],new_added=[],num_bills_replenished=[]}=form_data;
     
     let cashTotal=cash_cassettes.reduce(function(a, b){
      let bAmt=(b.deno??0)*(b.qty??0);
      return a + bAmt;
    },0);
    console.log("cashTotal",cashTotal)
    let divertTotal=divert_cassettes.reduce(function(a, b){
      let bAmt=(b.deno??0)*(b.qty??0);
      return a + bAmt;
    },0);
    let addedTotal=new_added.reduce(function(a, b){
      let bAmt=(b.deno??0)*(b.qty??0);
      return a + bAmt;
    },0);

    let billTotal=num_bills_replenished.reduce(function(a, b){
      let bAmt=(b.deno??0)*(b.qty??0);
      return a + bAmt;
    },0);
    let atm_balance =  (cashTotal??0)+(divertTotal??0);
    
    let differenceAmount=(form_data.cbs_host_balance??0)-atm_balance;

    let total_bills_replenished= billTotal??0;

     console.log("sourceList",sourceList)

    return (
      <div  style={{
        display: 'flex',
        flexDirection: 'column',
        gap:'16px'
      }}>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap:'16px'
        }}>
          <Row type='flex' justify='center' style={{
            flex: 1,
            gap:'16px'
          }}>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>Refill Date</span>
              <DatePicker
                name={'refill_date'}
                format={'YYYY-MM-DD'}
                showToday
                value={moment(form_data.refill_date, 'YYYY-MM-DD').isValid()
                  ? moment(form_data.refill_date, 'YYYY-MM-DD')
                  : null}
                onChange={(date, dateString) => {
                  this.stateUpdater({ stateKey: 'form_data', valueKey: 'refill_date', value: dateString })
                }}
              />
            </div>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>Branch Name</span>
              <Input
                  placeholder={"Branch Name"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'branch', value: e.target.value })
                  }}
                  value={form_data.branch}
                  >
                </Input>
            </div>
            </Row>
            <Row type='flex' justify='center' style={{
            flex: 1,
            gap:'16px'
          }}>
           <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>Terminal ID</span>
              <Select style={{ width: '100%' }}
                placeholder="Terminal ID"
                filterOption={(input, option) => option?.props?.value?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0}
                showSearch
                onSearch={(value)=>{
                  this.listSourcesExecutor.config({
                    params:{
                      query:value
                    }
                  }).execute();
                }}
                value={form_data.source_id}
                onChange={(value) => {
                  this.stateUpdater({ stateKey: 'form_data', valueKey: 'source_id', value: value })
                }}
              >
                {
                  sourceList.map((item, index) => {
                    console.log("itemis",item)
                    return <Select.Option value={item.source_id} key={item.source_id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
            </div>
            <div style={{flex:1,display:'flex',flexDirection:'column',gap:'4px'}}>
              <span>From CBS Host Balance (System Cash Balance)</span>
              <InputNumber 
              style={{
                width:'100%'
              }}
                placeholder={"CBS Host Balance"}
                onChange={(e) => {
                  this.stateUpdater({ stateKey: 'form_data', valueKey: 'cbs_host_balance', value: e })
                }}
              value={form_data.cbs_host_balance}
              />
              {/* <Input
                  placeholder={"CBS Host Balance"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'cbs_host_balance', value: e.target.value })
                  }}
                  value={form_data.cbs_host_balance}
                >
                </Input> */}
            </div>
            </Row>
            </div>
          <Divider style={{
            marginTop: 0,
            marginBottom: 0
          }} />
          <div style={{
            display:'flex',
            flexDirection:'column',
            gap:'8px'
          }}>
          <div className='table-head-title'>Bills from ATM Cash Cassettes</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={form_data.cash_cassettes??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                            render:(val,row,rowIndex)=>{
                              return <InputNumber min={0} onChange={(v)=>{
                                let value=parseInt(v??0);
                                let oldArrayItems=form_data.cash_cassettes??[];
                                let changedRow=form_data.cash_cassettes[rowIndex]??{};
                                changedRow['qty']=value;
                                changedRow['amt']=(changedRow['deno']??0)*(value??0);
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'cash_cassettes', value: oldArrayItems })
                              }} defaultValue={val} value={val} className='borderLess'/>
                            }
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                          {
                            title:"Cassette Type",
                            key:'cassette_type',
                            dataIndex:'cassette_type',
                            render:(val,row,rowIndex)=>{
                              return <Input value={val} onChange={(e)=>{
                                let oldArrayItems=form_data.cash_cassettes??[];
                                let changedRow=form_data.cash_cassettes[rowIndex]??{};
                                changedRow['cassette_type']=e.target.value;
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'cash_cassettes', value: oldArrayItems })
                              }} placeholder="Enter Cassette Type" className='borderLess' />
                            }
                          }
                        ]}
                        pagination={false}
                    />
          </div>
          <div className='col gap-16'>
          <div className='table-head-title'>Bills from ATM Divert Cassettes</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={form_data.divert_cassettes??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                            render:(val,row,rowIndex)=>{
                              return <InputNumber min={0} onChange={(v)=>{
                                let value=parseInt(v??0);
                                let oldArrayItems=form_data.divert_cassettes??[];
                                let changedRow=form_data.divert_cassettes[rowIndex]??{};
                                changedRow['qty']=value;
                                changedRow['amt']=(changedRow['deno']??0)*(value??0);
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'divert_cassettes', value: oldArrayItems })
                              }} defaultValue={val} value={val} className='borderLess'/>
                            }
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                          {
                            title:"Cassette Type",
                            key:'cassette_type',
                            dataIndex:'cassette_type',
                            render:(val,row,rowIndex)=>{
                              return <Input value={val} onChange={(e)=>{
                                let oldArrayItems=form_data.divert_cassettes??[];
                                let changedRow=form_data.divert_cassettes[rowIndex]??{};
                                changedRow['cassette_type']=e.target.value;
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'divert_cassettes', value: oldArrayItems })
                              }} placeholder="Enter Cassette Type" className='borderLess' />
                            }
                          }
                        ]}
                        pagination={false}
                    />
            <div style={{display:'flex',flexDirection:'row'}}>
              <div className='flex col gap-2'>
                <strong>Total Balance from ATM</strong>
                <div>{formatMoney(atm_balance)}</div>
              </div>
              <div className='flex col gap-2'>
                <strong>Difference</strong>
                <div>{formatMoney(differenceAmount)}</div>
              </div>
            </div>

            <div className='flex col gap-2'>
            <span>Remarks (Short / Excess / Reconciled)</span>
            <Input
                  placeholder={"Remarks"}
                  onChange={(e) => {
                    this.stateUpdater({ stateKey: 'form_data', valueKey: 'remarks', value: e.target.value })
                  }}
                  value={form_data.remarks}
                >
                </Input>
            </div>
          </div>
          <Divider style={{
            marginTop: 0,
            marginBottom: 0
          }} />
          <div className='col gap-16'>
          <div className='table-head-title'>New Added Cash Denominations</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={form_data.new_added??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                            render:(val,row,rowIndex)=>{
                              return <InputNumber min={0} onChange={(v)=>{
                                let value=parseInt(v??0);
                                let oldArrayItems=form_data.new_added??[];
                                let changedRow=form_data.new_added[rowIndex]??{};
                                changedRow['qty']=value;
                                changedRow['amt']=(changedRow['deno']??0)*(value??0);
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'new_added', value: oldArrayItems })
                              }} defaultValue={val} value={val} className='borderLess'/>
                            }
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                          {
                            title:"Cassette Type",
                            key:'cassette_type',
                            dataIndex:'cassette_type',
                            render:(val,row,rowIndex)=>{
                              return <Input value={val} onChange={(e)=>{
                                let oldArrayItems=form_data.new_added??[];
                                let changedRow=form_data.new_added[rowIndex]??{};
                                changedRow['cassette_type']=e.target.value;
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'new_added', value: oldArrayItems })
                              }} placeholder="Enter Cassette Type" className='borderLess' />
                            }
                          }
                        ]}
                        pagination={false}
                    />
          <div className='table-head-title'>Total Number of Bill Replenished (Previous + Added Denominations)</div>
          <Table
                        className='main-table editable-table'
                        size='small'
                        dataSource={form_data.num_bills_replenished??[]}
                        loading={false}
                        columns={[
                          {
                            title:"Denomination",
                            key:'deno',
                            dataIndex:'deno'
                          },
                          {
                            title:"Quantity",
                            key:'qty',
                            dataIndex:'qty',
                            render:(val,row,rowIndex)=>{
                              return <InputNumber min={0} onChange={(v)=>{
                                let value=parseInt(v??0);
                                let oldArrayItems=form_data.num_bills_replenished??[];
                                let changedRow=form_data.num_bills_replenished[rowIndex]??{};
                                changedRow['qty']=value;
                                changedRow['amt']=(changedRow['deno']??0)*(value??0);
                                oldArrayItems[rowIndex]=changedRow;
                                this.stateUpdater({ stateKey: 'form_data', valueKey: 'num_bills_replenished', value: oldArrayItems })
                              }} defaultValue={val} value={val} className='borderLess'/>
                            }
                          },
                          {
                            title:"Amount",
                            key:'amt',
                            dataIndex:'amt'
                          },
                        ]}
                        pagination={false}
                    />
           <div className='flex col gap-2'>
                <strong>Total Bills Replenished</strong>
                <div>{formatMoney(total_bills_replenished)}</div>
              </div>
          </div>
          <Divider style={{
            marginTop: 0,
            marginBottom: 0
          }} />
          <div className='col gap-16'>
          <Form
                hideTitle
                forCreate={this.state.edit_id==null}
                stringyfy={false}
                initialData={form_data}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("onChange",data);
                  this.setState({
                    ...form_data,
                    ...data
                  })
                }}
                fields={[
                  {
                    name:"Attach File or Snapshot",
                    index:'image',
                    type:'file',
                    show_update:false,
                    accept:'.jpg,.png,.jpeg'

                  },
                  {
                    name:"Request Date",
                    index:'request_date',
                    type:'date'
                  },
                  // {
                  //   name:"Entered By",
                  //   index:'entered_by',
                  //   type:'text'
                  // }
                ]}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
          </div>

          <br></br>
          <br></br>
          <Row type='flex' justify='space-between'>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                typeof this.props.onClose === 'function' && this.props.onClose()
              }}>Cancel</Button>
            </div>
            <div>
              <Button type='primary' onClick={() => {
                this.handlePostPatch()
              }}>Submit</Button>
            </div>
          </Row>


        </div>

    );
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.edit_id !== prevProps.edit_id || this.props.edit_data !== prevProps.edit_data) {
      this.setState({
        edit_id: this.props.edit_id,
        form_data: this.props.edit_data
      })
    };

  }
}

export default withDomains(RefillATMAddEdit,'activity','usergroups');
